module.exports = __webpack_public_path__ + "static/messageOverview-min-f9bc9a38c84e262be59acaf3d79975eb.svg";